module.exports = __webpack_public_path__ + "static/media/twobedroom.c165aa6b.png";